<template>
  <div class="w-80">
    <div id="stripe-custom-error-msg"><p class="help-block custom_error_msg"></p></div>
    <StripeElements
      v-if="stripeLoaded"
      v-slot="{ elements }"
      ref="elms"
      :stripe-key="stripeKey"
      :instance-options="instanceOptions"
      :elements-options="elementsOptions"
    >
      <StripeElement
        ref="card"
        :elements="elements"
        :options="cardOptions"
      />
      <div class="w-100">
        <div class="form-group w-100" style="margin-top: 20px;">
            <div><input id="check-agree" type="checkbox" @click="toggoleAgree"/> <label for="check-agree"> I agree to the terms and conditions of the <u><a target="_blanke" href="https://home.thelittapp.com/wp-content/uploads/2024/01/LITT-Global-Partner-Agreement-2024.pdf">LITT Reward Partner Agreement</a></u>. </label></div>
            <div id="error-msg" style="display: none;"><p class="help-block">Value is required</p></div>
        </div>
      </div>

      <div class="form-footer" style="width: 100% !important; justify-content: space-around !important;">
        <button style="width: 160px !important;" type="button" class="register-step-button" @click="prev()">Prev</button>
        <button style="width: 160px !important;" type="button" class="register-step-button" @click="pay">Submit</button>
        <!-- <div><input type="hidden" id="saveMerchantDetails" value="false" @click="this.submitForm"></div> -->
      </div>
      <div>
        <input type="hidden" id="paid" value="false" @click="next()"></div>
        <div><input type="hidden" id="showRunning" value="false" @click="showLoading()"></div>
        <div><input type="hidden" id="hideRunning" value="false" @click="hideLoading()"></div>
        <div><input type="hidden" id="countryCode" v-model="this.countryCode"></div>
        <div><input type="hidden" id="stripeKeyString" v-model="stripeKeyString"></div>
        <div><input type="hidden" id="storeName" v-model="this.storeName"></div>
        <div><input type="hidden" id="freeTrial" v-model="freeTrial"></div>
        <div><input type="hidden" id="joiningFee" v-model="joiningFee"></div>
        <div><input type="hidden" id="discountRemainingCycle" v-model="discountRemainingCycle"></div>
        <div><input type="hidden" id="discountedJoiningFee" v-model="joiningFee"></div>
        <div><input type="hidden" id="planFee" v-model="planFee"></div>
        <div><input type="hidden" id="planStartDate" v-model="planStartDate"></div>
        <div><input type="hidden" id="planEndDate" v-model="planEndDate"></div>
        <div><input type="hidden" id="chargePlanFeeNow" v-model="chargePlanFeeNow"></div>
        <div><input type="hidden" id="voucherCodeId" v-model="voucherCodeId"></div>
    </StripeElements>
  </div>
</template>

<script lang="js">
import { StripeElements, StripeElement } from 'vue-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { ref, onBeforeMount } from 'vue'
import axios from "axios";
import $ from 'jquery';

export default {
  name: 'CardStripe',
  components: {
    StripeElements,
    StripeElement,
  },
  inject: ['prev', 'next', 'showLoading', 'hideLoading'],
  props: ['cardHolder', 'countryCode', 'storeName', 'stripeKeyString', 'joiningFee', 
  'planFee', 'planStartDate', 'planEndDate', 'freeTrial', 'voucherCodeId', 
  'discountRemainingCycle', 'chargePlanFeeNow'],
  setup(props) {
    const stripeKey = ref(props.stripeKeyString);
    const instanceOptions = ref({
      // https://stripe.com/docs/js/initializing#init_stripe_js-options
    })
    const elementsOptions = ref({
      // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
    })
    const cardOptions = ref({
      hidePostalCode: true,
      classes: {
        base: "registration-stripe-main"
      }
    })

    const stripeLoaded = ref(false)
    const card = ref()
    const elms = ref()
    let agree = false

    onBeforeMount(() => {
      const stripePromise = loadStripe(stripeKey.value)
      
      stripePromise.then(() => {
        stripeLoaded.value = true
      })
    })

    const pay = () => {

      if ($("#check-agree").is(":checked")) {

        const cardElement = card.value.stripeElement
        const cardHolderName = cardHolder.value;

        elms.value.instance.createToken(cardElement).then((result) => {
          $("#showRunning").trigger("click");
          axios.post('save-credit-card', {
              "stripe_token": result.token.id,
              "card_holder_name": cardHolderName,
              "name": $("#storeName").val()
          }).catch(function (error) {
              $("#hideRunning").trigger("click");
              $(".custom_error_msg").html("Card verification failed. " + error);
              return false;
          }).then((res) => {
              if (res.data.status == 'false') {
                $("#hideRunning").trigger("click");
                $(".custom_error_msg").html("Card verification failed. " + res.data.error);
                return false;
              } else {
                axios.post('merchant-subscribe', {
                  'freeTrial': $('#freeTrial').val(),
                  'voucherCodeId': $('#voucherCodeId').val(),
                  'planStartDate': $('#planStartDate').val(),
                  'planEndDate': $('#planEndDate').val()
                }).catch((error)=>{
                  $("#hideRunning").trigger("click");
                  $(".custom_error_msg").html("Payment was unsuccessful. " + error);
                  return false;
                }).then((result)=>{
                  
                  $("#hideRunning").trigger("click");
                  if (result.data && result.data.status == 'true') {
                    $(".custom_error_msg").html("");
                    $("#paid").trigger("click");
                    return true;
                  } else {
                    $(".custom_error_msg").html("Payment was unsuccessful. " + result.data.error);
                    $("#paid").val(false);
                    return false;
                  }
                });
              }
          })
        }).catch((error)=>{
          $(".custom_error_msg").html("Please enter a valid card number and expiry date. \r\n");
          $("#hideRunning").trigger("click");
          return false;
      })
      } else {
        $("#error-msg").css("display", "block");
      }
    }

    return {
      stripeKey,
      stripeLoaded,
      instanceOptions,
      elementsOptions,
      cardOptions,
      card,
      elms,
      pay,
      agree
    }
  },
  methods: {
    toggoleAgree(){
        this.agree = !this.agree;
        if (this.agree) {
          $("#error-msg").css("display", "none");
        } else {
          $("#error-msg").css("display", "block");
        }
    }
  }
}
</script>
